export const QUICK_LINKS_CONFIG = [
  {
    group: "Summary Dashboard",
    mainPermission: "mnu_sum_dash",
    items: [
      {
        title: "Summary Dashboard",
        path: "/summary-dashboard",
        permission: "mnu_sum_dash",
      },
    ],
  },
  {
    group: "Work Queue",
    mainPermission: "mnu_work_queue",
    items: [
      {
        title: "Work Queue",
        path: "/workqueue",
        permission: "mnu_work_queue",
      },
    ],
  },
  {
    group: "ATM",
    mainPermission: "mnu_atm",
    items: [
      {
        title: "Dashboard",
        path: "/atm-drill-down",
        permission: "mnu_atm_dash",
      },
      {
        title: "ATM Balancing",
        path: "/device-view",
        permission: "mnu_atm_list",
      },
      {
        title: "Cash Replenishment",
        path: "/cash-replenishment",
        permission: "atm_cash_replenishment",
      },
    ],
  },
  {
    group: "Merchant",
    mainPermission: "mnu_merchant",
    items: [
      {
        title: "Summary Dashboard",
        path: "/merchant-dashboard",
        permission: "mnu_merchant_dash",
      },
      {
        title: "Transactions",
        path: "/merchant-transactions",
        permission: "mnu_merchant_dash",
      },
    ],
  },
  {
    group: "POS",
    mainPermission: "mnu_pos",
    items: [
      {
        title: "Dashboard",
        path: "/pos-dashboard",
        permission: "mnu_pos_dash",
      },
      {
        title: "Merchant List",
        path: "/pos-detail-view",
        permission: "mnu_mrchnt_list",
      },
    ],
  },
  {
    group: "Scheme & Networks",
    mainPermission: "mnu_scheme",
    items: [
      {
        title: "1-Link",
        path: "/schemes-1link",
        permission: "sub_menu_scheme_1_link",
      },
      {
        title: "RAAST",
        path: "/schemes-raast",
        permission: "sub_menu_scheme_raast",
      },
      {
        title: "UPI",
        path: "/schemes-upi",
        permission: "sub_menu_scheme_china_union_pay",
      },
      {
        title: "UAE Switch",
        path: "/schemes-uae-switch",
        permission: "sub_menu_scheme_uae_switch",
      },
      {
        title: "VISA",
        path: "/schemes-visa",
        permission: "sub_menu_scheme_visa",
      },
      {
        title: "Mastercard",
        path: "/schemes-master-card",
        permission: "sub_menu_scheme_mastercard",
      },
    ],
  },
  {
    group: "Branch",
    mainPermission: "mnu_branch",
    items: [
      {
        title: "Dashboard",
        path: "/branch-dashboard",
        permission: "mnu_branch_dash",
      },
      {
        title: "Branch List",
        path: "/branch-list",
        permission: "mnu_branch_list",
      },
    ],
  },
  {
    group: "Digital Platform",
    mainPermission: "mnu_digital",
    items: [
      {
        title: "Digital Platform",
        path: "/digital-platform",
        permission: "mnu_digital",
      },
    ],
  },
  {
    group: "Settlement Summary",
    mainPermission: "menu_settlement_summary",
    items: [
      {
        title: "1LINK",
        path: "/1link-atm",
        permission: "sub_menu_1link_settlement_summary",
      },
      {
        title: "UAE Switch",
        path: "/settlement-summary-uae-switch",
        permission: "sub_menu_uae_switch_settlement_summary",
      },
      {
        title: "VISA",
        path: "/settlement-summary-visa",
        permission: "sub_menu_visa_settlement_summary",
      },
      {
        title: "Mastercard",
        path: "/settlement-summary-master-card",
        permission: "sub_menu_mastercard_settlement_summary",
      },
    ],
  },
  {
    group: "Transactions",
    mainPermission: "mnu_txns",
    items: [
      {
        title: "Transaction Log",
        path: "/transaction-log",
        permission: "mnu_txns_log",
      },
      {
        title: "Matching",
        path: "/matching-pairs",
        permission: "mnu_txns_match",
      },
    ],
  },
  {
    group: "Operations",
    mainPermission: "mnu_ops",
    items: [
      {
        title: "Operations",
        path: "/operations",
        permission: "mnu_ops",
      },
    ],
  },
  {
    group: "Administration",
    mainPermission: "mnu_admin",
    items: [
      {
        title: "Account Management",
        path: "/account-management",
        permission: "mnu_account_mgmt",
      },
      {
        title: "Recon Account Management",
        path: "/recon-accounts-management",
        permission: "mnu_recon_account_mgmt",
      },
      {
        title: "ATM Management",
        path: "/atmlist",
        permission: "mnu_atm_mgmt",
      },
      {
        title: "Branch Management",
        path: "/branch-management",
        permission: "mnu_branch_mgmt",
      },
      {
        title: "Region Management",
        path: "/region-management",
        permission: "mnu_region_mgmt",
      },
      {
        title: "Institution Management",
        path: "/institution-management",
        permission: "mnu_inst_mgmt",
      },
      {
        title: "User Management",
        path: "/user-profile-management",
        permission: "mnu_user_mgmt",
      },
      {
        title: "Role Management",
        path: "/role-management",
        permission: "sub_menu_admin_role_management",
      },
      {
        title: "CIT Management",
        path: "/cit-management",
        permission: "mnu_cit_mgmt",
      },
      {
        title: "Team Management",
        path: "/team-management",
        permission: "sub_menu_admin_team_management",
      },
      {
        title: "Workflow Manager",
        path: "/workflow-manager",
        permission: "mnu_workflow_mgr",
      },
      {
        title: "Schedules",
        path: "/schedules",
        permission: "mnu_workflow_mgr",
      },
      {
        title: "Recon Calendar",
        path: "/recon-calendar",
        permission: "mnu_recon_calendar",
      },
      {
        title: "Interface Configuration",
        path: "/interface-configuration",
        permission: "mnu_interface_mgr",
      },
      {
        title: "Audit Log",
        path: "/audit-log",
        permission: "mnu_audit_log",
      },
      {
        title: "Settings",
        path: "/settings",
        permission: "mnu_settings",
      },
    ],
  },
  {
    group: "Event Log",
    mainPermission: "mnu_event_log",
    items: [
      {
        title: "Event Log",
        path: "/event-log",
        permission: "mnu_event_log",
      },
    ],
  },
  {
    group: "Reports",
    mainPermission: "mnu_reports",
    items: [
      {
        title: "System Reports",
        path: "/system-reports",
        permission: "mnu_system_reports",
      },
      {
        title: "User Reports",
        path: "/user-reports",
        permission: "mnu_user_reports",
      },
    ],
  },
];